// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { DimensionOut } from './dimensionOut.zod.ts';
import { PersonRef } from './personRef.zod.ts';
import { TemplateVariableOut } from './templateVariableOut.zod.ts';

export const PromptVersionDetailOut = zod.object({
  "answer_schema": zod.record(zod.string(), zod.unknown()),
  "created_at": zod.iso.datetime({"offset":true}),
  "created_by": zod.union([PersonRef,zod.null()]),
  "dimensions": zod.array(DimensionOut),
  "id": zod.uuid(),
  "is_current": zod.boolean(),
  "note": zod.string(),
  "run_count": zod.int(),
  "system_template": zod.string(),
  "system_variables": zod.array(TemplateVariableOut),
  "user_template": zod.string(),
  "user_variables": zod.array(TemplateVariableOut),
  "version": zod.int()
});

export type PromptVersionDetailOut = zod.input<typeof PromptVersionDetailOut>;
export type PromptVersionDetailOutOutput = zod.output<typeof PromptVersionDetailOut>;
